import * as React from 'react';

import './style.css';
import { makeValidateField, randomId } from './util';


import SelectBox from '../dropdown/SelectBox';

export default function InputTextSearch({field, formControls=undefined, setFormControls=undefined, className=undefined, style=undefined, disabled=false, password=false, elements=[], callback=()=>{}, onSelect=()=>{}, hidden}){
    let id = randomId();

    const [validity, setValidity] = React.useState({valid:true, warning:""})
    const [focus, setFocus]  = React.useState(false);

    const makeFieldChangeHandle = (field, setFormControls, validateField) => {

        return (e) => {
            setFormControls((prevState)=>{
                let newField = {value:e.target.value, validity:prevState[field.name].validity}
            if(callback!=undefined){
                callback(e);
            } else {
                console.log("FIELD CALLBACK UNDEFINED")
            }
            if(field.necessary){
                newField.validity = validateField(newField);
            }
            let newState = {}
            newState[field.name] = newField;
            return {
                ...prevState,
                ...newState
            }
            })
        }
    }


    const focusHandle = (e)=>{
            setFocus(()=>{
                return true;
            })
        }

        const blurHandle = (e)=>{
            setFocus(()=>{
                return false;
            })
        }

    let handleFieldChange = undefined;
    if(formControls!=undefined){
        const validateField = (field.necessary?makeValidateField(field, setValidity):undefined);
        handleFieldChange = makeFieldChangeHandle(field, setFormControls, validateField)
    }
  
    return (
        <div>
            <div hidden={field.hidden} className={"input-field "+(className!=undefined?className:"")} style={style}>
                <label htmlFor={id}>{field.label}</label>
                <input type={password?'password':'text'} disabled={field.disabled}  value={formControls!=undefined?formControls[field.name].value:""} onChange={handleFieldChange!=undefined?handleFieldChange:null} placeholder={field.placeholder!=undefined?field.placeholder:field.label} onFocus={focusHandle} onBlur={blurHandle} id={id}/>
                    {!formControls[field.name].validity.valid?<div className="warning">{formControls[field.name].validity.warning}</div>:<></>}
                
                </div>
                    <SelectBox hidden={!focus}  elements={elements} onSelect={onSelect} />
                </div>
                
    )
}
